import { Base64String, HtmlString } from '@front-app/services/SharedModels';

// From: https://stackoverflow.com/questions/30106476/using-javascripts-atob-to-decode-base64-doesnt-properly-decode-utf-8-strings
export function atobUtf8(encoded: string): string {
	try {
		return decodeURIComponent(window
			.atob(encoded)
			.split('')
			// eslint-disable-next-line
			.map((c) => `%${('00' + c.charCodeAt(0).toString(16)).slice(-2)}`)
			.join(''));
	} catch (e) {
		return window.atob(encoded);
	}
}

export function base64ToHtml(s: Base64String | null | undefined): HtmlString {
	if (s === null || s === undefined) {
		return '' as HtmlString;
	}
	return atobUtf8(s) as HtmlString;
}

export function compareTrimmedStringCharacters(string1: string, string2: string): boolean {
	return string1.trim().toLocaleLowerCase() === string2.trim().toLocaleLowerCase();
}

export const isEmptyString = (str?: string): boolean => !str || !str.trim();

export function stripHtml(string: string) {
	if ((string === null) || (string === '')) {
      	return false;
	} else {
      	string = string.toString();
	}

    // Regular expression to identify HTML tags in the input string. Replacing the identified HTML tag with a null string.
    return string.replace(/(<([^>]+)>)/ig, '');
}
